import { HttpService } from "./https.service";
import { BASE_URL } from "../../config/config";

const http = new HttpService();

// Link-in-Bio: block-based public page (/bio/:slug) per user with its own cctm_id.
// Link clicks tracked via /bio/r/:click_token; page views via /bio/track-view.
export class BioService {

    static async setupBioPage(data: any): Promise<any> {
        try {
            return await http.postRequest(BASE_URL + "/bio/setup", data, null);
        } catch (error) { throw new Error(`setupBioPage: ${error}`); }
    }

    static async getMyBioPage(influencer_id: number, account_id: number): Promise<any> {
        try {
            return await http.getRequest(BASE_URL + `/bio/my?influencer_id=${influencer_id}&account_id=${account_id}`, null);
        } catch (error) { throw new Error(`getMyBioPage: ${error}`); }
    }

    static async checkSlug(slug: string, influencer_id: number, account_id: number): Promise<any> {
        try {
            return await http.getRequest(BASE_URL + `/bio/slug-check?slug=${slug}&influencer_id=${influencer_id}&account_id=${account_id}`, null);
        } catch (error) { throw new Error(`checkSlug: ${error}`); }
    }

    static async addBlock(data: any): Promise<any> {
        try {
            return await http.postRequest(BASE_URL + "/bio/blocks", data, null);
        } catch (error) { throw new Error(`addBlock: ${error}`); }
    }

    static async updateBlock(data: any): Promise<any> {
        try {
            return await http.postRequest(BASE_URL + "/bio/blocks/update", data, null);
        } catch (error) { throw new Error(`updateBlock: ${error}`); }
    }

    static async deleteBlock(data: { bio_page_id: number; block_id: number }): Promise<any> {
        try {
            return await http.postRequest(BASE_URL + "/bio/blocks/delete", data, null);
        } catch (error) { throw new Error(`deleteBlock: ${error}`); }
    }

    static async reorderBlocks(data: { bio_page_id: number; order: number[] }): Promise<any> {
        try {
            return await http.postRequest(BASE_URL + "/bio/blocks/reorder", data, null);
        } catch (error) { throw new Error(`reorderBlocks: ${error}`); }
    }

    static async getAnalytics(params: { influencer_id: number; account_id: number; start_date?: string; end_date?: string }): Promise<any> {
        try {
            const query = new URLSearchParams(
                Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== '').map(([k, v]) => [k, String(v)]))
            ).toString();
            return await http.getRequest(BASE_URL + `/bio/analytics?${query}`, null);
        } catch (error) { throw new Error(`getAnalytics: ${error}`); }
    }

    static async getPublicBioPage(slug: string): Promise<any> {
        try {
            return await http.getRequest(BASE_URL + `/bio/view/${slug}`, null);
        } catch (error) { throw new Error(`getPublicBioPage: ${error}`); }
    }

    static async trackView(data: { slug: string; visitor_id: string; session_id: string }): Promise<any> {
        try {
            return await http.postRequest(BASE_URL + "/bio/track-view", data, null);
        } catch (error) { return null; }
    }

    static clickUrl(click_token: string): string {
        return `${BASE_URL}/bio/r/${click_token}`;
    }
}

// Theme presets shared by the editor and the public page.
export const BIO_THEMES: Record<string, { label: string; bg: string; accent: string; text: string; buttonText: string }> = {
    light:   { label: 'Light',   bg: '#FFFFFF', accent: '#111827', text: '#111827', buttonText: '#FFFFFF' },
    dark:    { label: 'Dark',    bg: '#111827', accent: '#F9FAFB', text: '#F9FAFB', buttonText: '#111827' },
    sunset:  { label: 'Sunset',  bg: '#FFF7ED', accent: '#EA7C3A', text: '#7C2D12', buttonText: '#FFFFFF' },
    ocean:   { label: 'Ocean',   bg: '#ECFEFF', accent: '#0E7490', text: '#083344', buttonText: '#FFFFFF' },
    grape:   { label: 'Grape',   bg: '#FAF5FF', accent: '#7C3AED', text: '#3B0764', buttonText: '#FFFFFF' },
};

export const BUTTON_SHAPES: Record<string, number> = { rounded: 12, pill: 999, square: 0 };
